import { ConsumerDobStepState } from './consumer-dob-step-state.interface'

export const createConsumerDobStepState = (): ConsumerDobStepState => ({
  dateOfBirth: null,
  error: null,
  isWorkflowStepComplete: false,
  loading: false,
})
